type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogEntry {
  level: LogLevel;
  message: string;
  data?: unknown;
  timestamp: string;
}

let _isDev: boolean | undefined = undefined;

// Allow test to override DEV mode
export function __setLoggerDevMode(val: boolean | undefined): void {
  _isDev = val;
}

const formatEntry = (level: LogLevel, message: string, data?: unknown): LogEntry => {
  return {
    level,
    message,
    data,
    timestamp: new Date().toISOString(),
  };
};

const emit = (entry: LogEntry): void => {
  const isDevelopment = typeof _isDev === 'boolean' ? _isDev : import.meta.env.DEV;
  if (!isDevelopment) {
    return;
  }
  const prefix = `[${entry.timestamp}] [${entry.level.toUpperCase()}]`;
  if (entry.level === 'debug') {
    // eslint-disable-next-line no-console
    console.debug(prefix, entry.message, entry.data ?? '');
    return;
  }
  if (entry.level === 'info') {
    // eslint-disable-next-line no-console
    console.info(prefix, entry.message, entry.data ?? '');
    return;
  }
  if (entry.level === 'warn') {
    // eslint-disable-next-line no-console
    console.warn(prefix, entry.message, entry.data ?? '');
    return;
  }
  // error
  // eslint-disable-next-line no-console
  console.error(prefix, entry.message, entry.data ?? '');
};

export const logger = {
  debug: (message: string, data?: unknown): void => emit(formatEntry('debug', message, data)),
  info: (message: string, data?: unknown): void => emit(formatEntry('info', message, data)),
  warn: (message: string, data?: unknown): void => emit(formatEntry('warn', message, data)),
  error: (message: string, data?: unknown): void => emit(formatEntry('error', message, data)),
} as const;
